import React, { forwardRef } from 'react';
import { alpha, Tooltip, useTheme } from '@mui/material';

const DSTooltip = forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof Tooltip>
>((props, ref) => {
  const { spacing, palette } = useTheme();
  const { children, ...otherProps } = props;

  const childElement = React.Children.only(children) as React.ReactElement;
  const isDisabled =
    (childElement?.props as { disabled?: boolean })?.disabled === true;

  const wrappedChildren = isDisabled ? (
    <span style={{ display: 'inline-block', cursor: 'not-allowed' }}>
      {children}
    </span>
  ) : (
    children
  );

  return (
    <Tooltip
      ref={ref}
      {...otherProps}
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            fontSize: spacing(2),
            padding: spacing(3),
            borderRadius: spacing(3),
            whiteSpace: 'pre-wrap',
            maxWidth: 'none',
            backgroundColor: alpha(palette.paper.elevation24, 0.98),
            ...props.componentsProps?.tooltip?.sx,
          },
        },
        arrow: {
          sx: {
            color: alpha(palette.paper.elevation24, 0.98),
            ...props.componentsProps?.arrow?.sx,
          },
        },
      }}
    >
      {wrappedChildren}
    </Tooltip>
  );
});

export default DSTooltip;
